import React from 'react';
import Item from './item';

export default class Studies extends React.Component {
  render() {
    let {
      search,
      checked,
      onChecked,
      studies,
      archived,
      empty,
      loading,
      lastColumn,
    } = this.props;
    if (!studies) return <p>....</p>;
    if (studies && studies.length === 0) return <p>{empty}</p>;
    return (
      <table style={{ opacity: loading ? 0.5 : 1 }}>
        <thead>
          <tr>
            {checked
              ? <th className="check">
                  <input
                    id="check-all"
                    type="checkbox"
                    name="all"
                    value="true"
                    onChange={e =>
                      onChecked(
                        e.target.checked ? studies.map(study => study.id) : []
                      )}
                  />
                </th>
              : null}
            <th className="study">Study</th>
            <th className="patient">Patient</th>
            <th className="company">Company</th>
            <th className="scorer">
              {lastColumn
                ? lastColumn
                : search ? 'Created' : archived ? 'Scored' : 'Scorer'}
            </th>
          </tr>
        </thead>
        <tbody>
          {studies.map(study =>
            <Item
              key={study.id}
              study={study}
              search={search}
              lastColumn={lastColumn}
              checked={checked}
              onCheck={() => {
                let newChecked = [...checked];
                let index = newChecked.findIndex(item => item === study.id);
                if (index > -1) newChecked.splice(index, 1);
                else newChecked.push(study.id);
                onChecked(newChecked);
              }}
            />
          )}
        </tbody>
      </table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/shared/studies/index.js